
//filter results
import {showMessage} from "./modals";
import {updateBaseUrl, updateQueryStringParameter} from "./helpers";

const filterResults = (el) => {
    const currentInputValue = el.value.toLowerCase();
    let filteredElement = null;

    //filter table
    if (el.dataset.filteredTable && (filteredElement = document.querySelector(el.dataset.filteredTable))) {
        filteredElement.querySelectorAll('tr').forEach((tr) => {
            const tds = tr.querySelectorAll('td');

            let needToRemoveRow = tds.length > 0;

            tr.classList.remove('d-none');

            tds.forEach((td) => {
                if (-1 !== td.innerText.toLowerCase().indexOf(currentInputValue)) {
                    needToRemoveRow = false;
                }
            })

            if (needToRemoveRow) {
                tr.classList.add('d-none');
            }
        });
    }

    //filter blocks
    if (el.dataset.filteredBlock && (filteredElement = document.querySelector(el.dataset.filteredBlock))) {
        filteredElement.querySelectorAll('.js-live-filter-block-item').forEach((item) => {
            const items = item.querySelectorAll('*');

            let needToRemoveBlock = items.length > 0;

            item.classList.remove('d-none');

            items.forEach((innerEl) => {
                if (innerEl.innerText && -1 !== innerEl.innerText.toLowerCase().indexOf(currentInputValue)) {
                    needToRemoveBlock = false;
                }
            })

            if (needToRemoveBlock) {
                item.classList.add('d-none');
            }
        });
    }
};

//"live" search
if (document.querySelector('.js-live-filter-input')) {
    //input events
    document.querySelectorAll('.js-live-filter-input').forEach((el) => {
        el.addEventListener('input', () => {
            filterResults(el);
        });
        if ($.trim(el.value) !== '') {
            filterResults(el);
        }
    });
}
if(document.querySelector('.js-live-filter-btn')) {
    //button events
    document.querySelectorAll('.js-live-filter-btn').forEach((el) => {
        el.addEventListener('click', (e) => {
            if ($.trim(el.closest('.js-live-filter-block').querySelector('.js-live-filter-input').value) === '') {
                e.preventDefault();
                return false;
            }
            filterResults(el.closest('.js-live-filter-block').querySelector('.js-live-filter-input'));
        });
    });
}

// Beverages

// Если пользователь слишком быстро клацал создаём стек запросов на подгрузку фильтров и поочереди выполняем

class Filter {
    constructor($container, filterMenuData, selected) {
        // Main container filter
        this.$container = $container;

        // Dynamical tree data - props and variables
        this.filterMenuData = filterMenuData;

        // The queue of execution of the selected filters while waiting for the menu data to be loaded
        this.queue = [];
        this.tabLoad = false;

        // Look interface
        this.look = false;

        // Selected for backend format
        this.currentSelectedCategory = [];
        // Clicked breadcrumb item
        this.currentClickedBreadcrumb = [];

        // Save selected condition for each tab
        this.tabsSelected = {};

        // Инициализировать выбранные если по ссылке с выбранным фильтром перешли
        if(selected) {
            this.setInitialSelected(selected);
        } else {
            this.selected = {tabSlug: null, params: []};
        }

        // Binding event handlers
        let self = this;
        self.handlerSelectTab($('.tab_main .nav-link.active').first());
        this.$container.find(' .tab_main').on('click', ' .nav-link', function () {self.handlerSelectTab($(this))});
        this.$container.find(' .filter-list').on('click', ' li[data-filter-param]', function () {self.handlerReSelectBreadcrumb($(this))});
        this.$container.find(' .filter-partials').on('click', ' .js-btn-variable', function () {self.handlerSelectVariable($(this))});

        $(window).on('popstate', function (e) {self.handlerBack(e)});
    }

    // Инициализация выбора прописонного в url в параметре "selectedFilter"
    setInitialSelected (selected) {
        this.selected = selected;
        if (this.selected.tabSlug) {
            this.tabsSelected[this.selected.tabSlug] = $.extend(true, {}, this.selected);
            this.renderBreadcrumbSelected();
        }
    }

    // Выбор таба
    handlerSelectTab ($this) {
        if(this.queue.length) {
            this.queue.length = 0;
            this.look = false;
        }

        let tabSlug = $this.attr('aria-controls');
        console.log('this.tabsSelected', this.tabsSelected, tabSlug)
        if(tabSlug in this.tabsSelected) {
            this.selected = $.extend(true, {}, this.tabsSelected[tabSlug]);

            this.hideLoader();
            this.hideVariables();
            this.showTabContent();

            this.renderBreadcrumbSelected();
        } else {
            this.selected.params = [];
            console.log('ff', tabSlug, this.filterMenuData[tabSlug])
            if(tabSlug in this.filterMenuData && 'children' in this.filterMenuData[tabSlug]) {
                this.showVariables();
                this.hideTabContent();

                this.selected.tabSlug = tabSlug;

                let paramsTab = this.filterMenuData[tabSlug]['children'] || [];
                let paramSlug = Object.keys(paramsTab)[0];
                let param = paramsTab[paramSlug];

                let variables = param['children'] || {};
                let notLoaded = Object.keys(variables).some(function (el) {return variables[el]['not_loaded']});

                this.renderBreadcrumbSelected();
                this.renderVariables();

                if(notLoaded) {
                    this.tabLoad = true;
                    this.loadFilterData(() => {
                        this.tabLoad = false;
                        this.look = false;
                        this.checkQueue();
                    });
                }
            } else {
                this.selected.tabSlug = tabSlug;
                this.selected.params = [];

                this.hideLoader();
                this.hideVariables();
                this.showTabContent();

                this.renderBreadcrumbSelected();
                this.renderVariables();
                this.setUrlCurSelectFilter(this.$container.data('route'), false)
            }
        }
    }

    // Re select filter breadcrumb
    handlerReSelectBreadcrumb ($this) {
        let paramName = $this.attr('data-filter-param');
        this.currentClickedBreadcrumb = paramName
        // Save selected before click param other delete
        for (let i in this.selected.params) {
            if(this.selected.params[i].slug === paramName) {
                this.selected.params.length = i;
                break;
            }
        }
        this.hideLoader();
        this.hideTabContent();
        this.showVariables();

        this.renderBreadcrumbSelected();
        this.renderVariables();
    }

    // Выбор варианта параметра фильтра
    handlerSelectVariable ($this) {
        if (!this.look) {
            this.queue.push($this);
            if((this.tabLoad ? 1 : 0) + this.queue.length >= 2) {
                this.look = true;
            } else {
                this.checkQueue();
            }
        }
    }

    // Рекурсия выполленения очереди выбранных вариантов параметров и их выполнение
    checkQueue() {
        if(this.queue.length) {
            this.selectVariable(this.queue[0], (() => {
                this.look = false;
                this.queue.shift();
                if(this.queue.length) {
                    this.checkQueue();
                }
            }));
        }
    }

    /**
     * Select variabre for prop
     * @param $this - jQuery element
     * @param cb - callback run after load filter menu data or end method execution
     */
    selectVariable($this, cb) {
        let selectParamSlug = $this.attr('data-param');
        let selectVariableSlug = $this.attr('data-value');

        this.selected.params.push({slug: selectParamSlug, value: selectVariableSlug});

        let paramsTab = this.filterMenuData[this.selected.tabSlug]['children'] || [];

        if(this.currentClickedBreadcrumb && this.currentClickedBreadcrumb in paramsTab) {
            paramsTab = paramsTab[this.currentClickedBreadcrumb]['children'] || []
        }

        let paramSlug = Object.keys(paramsTab)[0];
        let param = paramsTab[paramSlug] || {};
        let variables = param['children'] || {};
        let notLoaded = Object.keys(variables).some(function (el) {return variables[el]['not_loaded']});
        console.log('ss', this.selected.params)
        for (let key in this.selected.params) {
            let variable = this.selected.params[key];
            console.log('fdsfsdfsd', paramsTab, variables, variable.value)
            if (variables[variable.value] && variables[variable.value]['not_loaded'] || !(variable.value in variables)) {
                break;
            }
            if(variables[variable.value] && !variables[variable.value]['not_loaded'] && !('children' in variables[variable.value])) {
                this.loadItemsList();
                this.tabsSelected[this.selected.tabSlug] = $.extend(true, {}, this.selected);
                break;
            }
            paramsTab = variables[variable.value]['children'];
            paramSlug = Object.keys(paramsTab)[0];
            param = paramsTab[paramSlug] || {};
            variables = param['children'] || {};
            notLoaded = Object.keys(variables).some(function (el) {return variables[el]['not_loaded']}) || false;
        }

        this.renderBreadcrumbSelected();
        this.renderVariables();

        if(notLoaded) {
            this.loadFilterData(cb);
        } else {
            if(typeof cb === 'function') {
                cb(true);
            }
        }
    }

    /**
     * Load props and variables 2 level nested for select variable
     * @param cb - callback run after load filter menu data or error
     */
    loadFilterData(cb) {
        // Transform select data for backend
        this.currentSelectedCategory = [];
        if(this.selected.tabSlug) {
            this.currentSelectedCategory.push(this.selected.tabSlug);
            this.selected.params.forEach((param) => {
                this.currentSelectedCategory.push(param.slug);
                this.currentSelectedCategory.push(param.value);
            });
        }

        let curr = this.currentSelectedCategory.length ? '/' + this.currentSelectedCategory.join('/') : '';

        $.ajax({
            type: 'get',
            url: this.$container.data('route') + curr + '/filter?isAjax=Y',
            cache: false,
            data: {
                //currentSelectedCategory: curr,
                '_token': $('meta[name="csrf-token"]').attr('content'),
                '_': $.now(),
            },
            success: (data) => {
                if(this.selected.params.length === 0) {
                    //console.log($.extend(true, {}, this.filterMenuData[this.selected.tabSlug]['children']), $.extend(true, {}, data));
                    this.filterMenuData[this.selected.tabSlug] = data;
                } else {
                    let paramsTab = this.filterMenuData[this.selected.tabSlug]['children'] || [];
                    let paramSlug = Object.keys(paramsTab)[0];
                    let param = paramsTab[paramSlug];
                    let variables = param['children'];

                    for (let key in this.selected.params) {
                        let variable = this.selected.params[key];
                        if(parseInt(key) >= this.selected.params.length - 1) {
                            //console.log($.extend(true, {}, variables[variable.value]['children']), $.extend(true, {}, data));
                            variables[variable.value] = data;
                            variables[variable.value]['not_loaded'] = false;
                            break;
                        }
                        paramsTab = variables[variable.value]['children'];
                        paramSlug = Object.keys(paramsTab)[0];
                        param = paramsTab[paramSlug];
                        variables = param['children'];
                    }
                }

                if(typeof cb === "function") {
                    cb(true);
                }

            },
            error: function (xhr) {
                if(typeof cb === 'function') {
                    cb(false);
                }
            }
        });
    }

    // Generate and insert HTML breadcrumbs params
    renderBreadcrumbSelected() {
        this.$container.find(' .filter-list').empty();
        let result = '';
        if(this.selected.tabSlug !== null && this.selected.tabSlug in this.filterMenuData /*&& (this.filterMenuData[this.selected.tabSlug]['children'] || []).length*/) {
            let paramsTab = this.filterMenuData[this.selected.tabSlug]['children'] || [];
            if(this.currentClickedBreadcrumb && this.currentClickedBreadcrumb in paramsTab) {
                paramsTab = paramsTab[this.currentClickedBreadcrumb]['children'] || []
            }
            if(!Object.keys(paramsTab).length) {
                return ;
            }
            let paramSlug, param, variables, notLoaded, variableExists, paramName;
            console.log('fdsfsd', paramsTab)
            if(Object.keys(paramsTab).length > 1) {
                for(const [key, value] of Object.entries(paramsTab)) {
                    paramSlug = key;
                    param = value || {};
                    variables = param['children'] || [];
                    notLoaded = Object.keys(variables).some(function (el) {
                        return variables[el]['not_loaded']
                    }) || false;

                    variableExists = this.selected.params.length && this.selected.params[0].value in variables;
                    paramName = variableExists ? variables[this.selected.params[0].value].name : param.name;

                    if (paramName) {
                        result += `<li class="${variableExists ? '' : 'selection'}" data-filter-param="${paramSlug}">${paramName}</li>`;
                    }
                }
            } else {
                paramSlug = Object.keys(paramsTab)[0];
                param = paramsTab[paramSlug] || {};
                variables = param['children'] || [];
                notLoaded = Object.keys(variables).some(function (el) {
                    return variables[el]['not_loaded']
                }) || false;

                variableExists = this.selected.params.length && this.selected.params[0].value in variables;
                paramName = variableExists ? variables[this.selected.params[0].value].name : param.name;
                if (paramName) {
                    result += `<li class="${variableExists ? '' : 'selection'}" data-filter-param="${paramSlug}">${paramName}</li>`;
                }

            }

            for (let key in this.selected.params) {
                let variable = this.selected.params[key];
                if (!(variable.value in variables) || !('not_loaded' in variables[variable.value]) && variables[variable.value]['not_loaded']) {
                    break;
                }
                if (('not_loaded' in variables[variable.value]) && !variables[variable.value]['not_loaded'] && !('children' in variables[variable.value])) {
                    break;
                }
                paramsTab = variables[variable.value]['children'] || {};
                paramSlug = Object.keys(paramsTab)[0] || {};
                param = paramsTab[paramSlug] || {};
                variables = param['children'] || {};
                notLoaded = Object.keys(variables).some(function (el) {
                    return variables[el]['not_loaded']
                });
                let variableExists = parseInt(key) < this.selected.params.length - 1 && this.selected.params[parseInt(key) + 1].value in variables;
                paramName = variableExists ? variables[this.selected.params[parseInt(key) + 1].value].name : param.name
                if (paramName) {
                    result += `<li class="${variableExists ? '' : 'selection'}" data-filter-param="${paramSlug}">${paramName}</li>`;
                }
                console.log('ffffff', this.selected.params, variable, variables, paramName, variableExists, variables)
            }

            this.$container.find(' .filter-list').append(result);
        }
    }

    // Generate and insert HTML param variables
    renderVariables() {
        this.$container.find(' .filter-variables').empty();

        console.log(this)
        if(this.selected.tabSlug !== null && this.selected.tabSlug in this.filterMenuData) {
            let paramsTab = this.filterMenuData[this.selected.tabSlug]['children'] || [];
            if(this.currentClickedBreadcrumb && this.currentClickedBreadcrumb in paramsTab) {
                paramsTab = paramsTab[this.currentClickedBreadcrumb]['children'] || []
            }
            let paramSlug, param, variables = [], notLoaded = false;

            if(Object.keys(paramsTab).length > 1) {
                for(const [key, value] of Object.entries(paramsTab)) {
                    paramSlug = key;
                    param = value || {};
                    /*variables = param['children'] || [];
                    notLoaded = Object.keys(variables).some(function (el) {
                        return variables[el]['not_loaded']
                    }) || false;*/
                }
            } else {
                paramSlug = Object.keys(paramsTab)[0];
                param = paramsTab[paramSlug] || {};
                variables = param['children'] || {};
                notLoaded = Object.keys(variables).some(function (el) {
                    return variables[el]['not_loaded']
                });
            }

            for (let key in this.selected.params) {
                let variable = this.selected.params[key];
                if (!(variable.value in variables) || variables[variable.value]['not_loaded']) {
                    break;
                }
                if(!variables[variable.value]['not_loaded'] && !('children' in variables[variable.value])) {
                    break;
                }
                paramsTab = variables[variable.value]['children'] || {};
                console.log('fsdfs', key, paramsTab)
                paramSlug = Object.keys(paramsTab)[0] || {};
                param = paramsTab[paramSlug] || {};
                variables = param['children'] || {};
                notLoaded = Object.keys(variables).some(function (el) {return variables[el]['not_loaded']}) || false;
            }

            let result = '';
            for(let key in variables) {
                result += `<div class="col-6 col-md-4 col-lg-3 p-1 p-md-2">
                        <button type="button" class="card-info-extend __big js-btn-variable ${!variables[key].img ? '__not-image' : ''}" data-param="${paramSlug}" data-value="${key}">
                            `+(variables[key].img ? `<div class="card-icon">
                                <img src="${variables[key].img}" alt="Icon">
                            </div>` : '')+`
                            <p class="card-text">${variables[key].name}</p>
                        </button>
                    </div>`;
            }

            this.$container.find(' .filter-variables').append(result);
        }
    }

    // Load list tovars by selected filter
    loadItemsList(notPushHistory) {
        this.currentSelectedCategory = [];
        if(this.selected.tabSlug) {
            this.currentSelectedCategory.push(this.selected.tabSlug);
            this.selected.params.forEach((param) => {
                this.currentSelectedCategory.push(param.slug);
                this.currentSelectedCategory.push(param.value);
            });
        }

        let curr = this.currentSelectedCategory.length ? '/' + this.currentSelectedCategory.join('/') : '';

        let ajaxUrl = this.$container.data('route') + curr;

        this.setUrlCurSelectFilter(ajaxUrl, notPushHistory);
        this.hideVariables();
        this.showLoader();

        // $.get(this.$container.data('route') + '/filter/items', {
        //     'selectedFilter': this.$container.data('root-slug') + '.' + curr,//beverages.children.wine.bottle.red.suh
        // }, (ans) => {
        $.get(ajaxUrl, { '_': $.now() }, (ans) => {
            this.hideLoader();
            this.showTabContent();
            this.$container.find(' .tab-pane.active .js-live-filter-block-items').empty().append($(ans).removeClass('infinite-scroll-for-tabs js-live-filter-block-items '));
        })
    }

    showVariables() {
        /*.css("display", "flex").hide().fadeIn(2000);*/
        this.$container.find(' .filter-partials').stop(true, true).fadeIn();
    }

    hideVariables() {
        this.$container.find(' .filter-partials').stop(true, true).fadeOut(0);
    }

    showTabContent() {
        this.$container.find(' .tab-content').stop(true, true).fadeIn();
        this.$container.find(' .nav-link.active').trigger('filter.show.tab.content');
    }

    hideTabContent() {
        this.$container.find(' .tab-content').stop(true, true).fadeOut(0);
    }

    showLoader() {
        this.$container.find(' .load-tab-spinner').css('height', '100vw').append('<div class="spinner-border spinner-color"></div>');
    }

    hideLoader() {
        this.$container.find(' .load-tab-spinner').css('height', '').empty();
    }

    setUrlCurSelectFilter(selectedFilter, notPushHistory, replace) {
        replace = replace || false
        //updateQueryStringParameter('selectedFilter', selectedFilter, notPushHistory);
        updateBaseUrl(selectedFilter, notPushHistory, replace);
    }

    handlerBack(e) {
        if (e.originalEvent.state && e.originalEvent.state.selected) {
            if(this.queue.length) {
                this.queue.length = 0;
            }

            let tabSlug = e.originalEvent.state.selected.tabSlug;
            if(tabSlug in this.tabsSelected && this.selected.tabSlug !== tabSlug) {
                this.selected = $.extend(true, {}, this.tabsSelected[tabSlug]);

                this.hideLoader();
                this.hideVariables();
                this.showTabContent();

                this.$container.find('.nav-item a[href="#items-' + tabSlug + '"]').tab('show');
            } else {
                this.selected = e.originalEvent.state.selected;

                this.loadItemsList(true);
            }
        } else {
            this.selected = {tabSlug: null, params: []};

            this.$container.find('.nav-item a[href="#items-all"]').tab('show');
        }

        this.renderBreadcrumbSelected();
    }
}

$('.js-tab-filter').each(function () {
    new Filter($(this), filterBeverages, selected);
});

document.addEventListener('keydown', function (e) {
    if (e.keyCode == 119) { // F8
        debugger;
    }
}, {
    capture: true
});
